import { config } from "@config/config";

import { FronteraEhrLearnerExportStatusEnum, ReportFronteraEhrClientExportQuery } from "@api/graphql/types-and-hooks";

export const fronteraEhrClientExportQueryKey = (reportId: string) => ["report-frontera-ehr-client-export", reportId];

export const exportNodeOf = (data: ReportFronteraEhrClientExportQuery | undefined) =>
  data?.getReports?.edges?.[0]?.node;

export const pollWhileExportPending = (query: { state: { data?: ReportFronteraEhrClientExportQuery } }) =>
  exportNodeOf(query.state.data)?.fronteraEhrClientExport?.status === FronteraEhrLearnerExportStatusEnum.Pending
    ? config.REPORT_POLLING_INTERVAL
    : false;
